import Loader from "../../components/Loader";
import "./index.scss";

const GlobalLoadScreen = (props) => (
  <div className="global-loading">
    <Loader />
  </div>
);
export default GlobalLoadScreen;
